<template>
  <div class="container">
    <h2 class="title">
      <span>Easy to use</span>
      How does it work?
    </h2>
    <div class="how-it-works">
      <div class="row">
        <div class="block col-xs-12 col-md-3">
          <p class="title">
            <span>1.</span>Hire a Coach
          </p>
          <p class="description">
            Browse through the finest cricket coaches across the globe.
          </p>
        </div>
        <div class="block col-xs-12 col-md-3">
          <p class="title">
            <span>2.</span> Record &#38; Upload
          </p>
          <p class="description">
            Record &#38; upload your training videos using any camera device at
            your disposal.
          </p>
        </div>
        <div class="block col-xs-12 col-md-3">
          <p class="title">
            <span>3.</span> Video Analysis
          </p>
          <p class="description">
            Your coach will review your videos within the next 24 hours using
            our Smart Video Analysis tools.
          </p>
        </div>
        <div class="block col-xs-12 col-md-3">
          <p class="title">
            <span>4.</span> Feedback &#38; Drills
          </p>
          <p class="description">
            You will receive actionable feedback and drills to improve your
            game.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Features",
  mounted() {
    // Tracking code
    this.$ma.trackEvent({
      fb_event: "ViewContent",
      category: "Menu",
      action: "Menu",
      label: "Features",
      type: "Features",
    });
  },
  // metaInfo() {
  //   return {
  //     title: this.textEllipsis(`Ludimos - How it works`, 25),
  //     // meta: [{ name: "theme-color", content: this.getPrimaryHex }]
  //   };
  // },
};
</script>
<style scoped lang="scss">
.how-it-works {
  .block {
    .title {
      font-size: 20px;
      margin-bottom: 0;
      span {
        font-size: 70px;
        color: #6335ff;
        font-weight: 600;
        display: block;
        line-height: 70px;
        opacity: 0.2;
      }
    }
    .description {
      opacity: 0.8;
      font-size: 14px;
      line-height: 24px;
    }
  }
  .title {
    font-weight: 600;
  }
}
</style>
